export const escapeRegex = (toEscape: string) => toEscape.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
